<template>
  <div>
    <b-form-group>
     <!-- <b-form-radio v-model="selectedOption" name="some-radios" value="a"
        >Búsqueda completa</b-form-radio
      > -->
      <b-form-radio v-model="selectedOption" name="some-radios-1" value="b"
        >Búsqueda por TRX
      </b-form-radio>
    </b-form-group>
    <slot name="button-search"> </slot>
    <slot name="button-cancel"> </slot>
  </div>
</template>
<script>
export default {
  name: "ModalGeneric",
  data() {
    return {
      selectedOption: "b",
      infoModal: {
        id: "info-modal",
        title: "",
        content: [],
      },
    };
  },
  methods: {

  },
};
</script>
<style scoped>

</style>